export default "__VITE_ASSET__7539a30a__"